import { render, staticRenderFns } from "./BusinessMetricsSum.vue?vue&type=template&id=2420ef9c&scoped=true"
import script from "./BusinessMetricsSum.vue?vue&type=script&lang=js"
export * from "./BusinessMetricsSum.vue?vue&type=script&lang=js"
import style0 from "./BusinessMetricsSum.vue?vue&type=style&index=0&id=2420ef9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420ef9c",
  null
  
)

export default component.exports